import getNearestNodeWithSameCommentId from "@ext/markdown/elements/comment/edit/logic/utils/getNearestNodeWithSameCommentId";
import type { EditorState } from "@tiptap/pm/state";

/** The id of the comment a position sits inside; a block keeps its comment in its attributes, so the ancestors count too. */
const getCommentIdAtPosition = (state: EditorState, position: number): string | null => {
	const node = state.doc.nodeAt(position);

	const mark = node?.marks.find((mark) => mark.type.name === "comment");
	if (mark) return mark.attrs.id ?? null;
	if (node?.attrs.comment?.id) return node.attrs.comment.id;

	const resolved = state.doc.resolve(position);
	for (let depth = resolved.depth; depth > 0; depth--) {
		const id = resolved.node(depth).attrs.comment?.id;
		if (id) return id;
	}

	return null;
};

/** The range the comment covers, found from a position inside it: through the ancestors first, then among the siblings. */
export const getCommentRangeAtPosition = (state: EditorState, position: number, commentId: string) => {
	const resolved = state.doc.resolve(position);

	for (let depth = resolved.depth; depth > 0; depth--) {
		if (resolved.node(depth).attrs.comment?.id !== commentId) continue;
		const from = resolved.before(depth);
		return { from, to: from + resolved.node(depth).nodeSize };
	}

	return getNearestNodeWithSameCommentId(state, position, commentId);
};

export default getCommentIdAtPosition;
